import { isDarkTheme } from '@/constants/Colors';

const light = {
  surface: '#FFFFFF',
  preview: '#F5F5F7',
  hover: '#EFEFF2',
  control: '#FFFFFF',
  border: '#E7E7EA',
  activeBorder: '#8E8E93',
  selected: '#EDEDF1',
  ink: '#242426',
  onInk: '#FFFFFF',
  icon: '#6E6E73',
  paper: '#FFFFFF',
  blue: '#4776B8',
  red: '#BE5C51',
  green: '#487D61',
  orange: '#B8793F',
  purple: '#8665AD',
};

const dark = {
  surface: '#1C1C1E',
  preview: '#242426',
  hover: '#2C2C2F',
  control: '#3A3A3D',
  border: '#363639',
  activeBorder: '#8E8E93',
  selected: '#333337',
  ink: '#F5F5F7',
  onInk: '#1C1C1E',
  icon: '#A1A1A6',
  paper: '#343437',
  blue: '#91B5EB',
  red: '#EAA096',
  green: '#9AC5AA',
  orange: '#E3B17E',
  purple: '#BBA5DB',
};

export const getLibraryPalette = theme => isDarkTheme(theme) ? dark : light;
